import { Box, Typography } from "@mui/material";

const NotFound = () => {
  return (
    <Box
      className="loading-wrapper"
      display="flex"
      alignItems="center"
      justifyContent="center"
      position="absolute"
      top={0}
      left={0}
      right={0}
      bottom={0}
      zIndex={10}
      sx={{
        bgcolor: "bgs.transparent",
        pointerEvents: "none"
      }}
    >
      <Typography textAlign="center">
        <b>404</b>: pagina non trovata
      </Typography>
    </Box>
  );
};

export default NotFound;
